module.exports = __webpack_public_path__ + "static/media/column_headers_example.c5387479.png";